import React from 'react';
import { Switcher } from '@adjust/dashboard-components';
import { connectWithStore } from '@react/Common/connectWithStore';
import { getAccountNonCamelCase } from '@redux/ducks/global';
import { getUserPermissionsState, toggleFeature, updateFeatures } from '@redux/ducks/userPermissions/userPermissions';
import { getFeaturesForForm } from './utils';

const FeatureTogglerComponent = ({ feature, toggleFeature }) => {
  const handleSwitcherChange = event => {
    const { checked, name } = event.target;
    toggleFeature({ value: checked, name });
  };

  return (
    <li>
      <Switcher value={feature.enabled} name={feature.key} label={t(feature.name)} onChange={handleSwitcherChange} />
    </li>
  );
};

const mapStateToDispatch = { toggleFeature };

const FeatureToggler = connectWithStore(null, mapStateToDispatch)(FeatureTogglerComponent);

const ToggleFeaturesComponent = ({ isNewUser, isNotAdminUser, featureList, updateFeatures }) => {
  React.useEffect(() => {
    if (isNewUser) {
      const initialFeatureValue = featureList.map(feature => ({
        name: feature.key,
        role: feature.enabled ? 'reader' : 'none',
      }));
      updateFeatures(initialFeatureValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return isNotAdminUser ? (
    <div>
      <div className="panel-section">
        <div className="form-row form-row-tight">
          <label>{t('label.feature-access')}</label>

          <ul className="feature-access">
            {featureList.map(feature => (
              <FeatureToggler key={feature.key} feature={feature} />
            ))}
          </ul>
        </div>
      </div>
    </div>
  ) : null;
};

const mapStateToProps = state => {
  const account = getAccountNonCamelCase(state);
  const { user } = getUserPermissionsState(state);

  const featureList = getFeaturesForForm(user, account);
  const isNotAdminUser = user?.role !== 'admin' && !user?.super_admin;

  return { featureList, isNotAdminUser, isNewUser: !user?.id };
};

const mapComponentStateToDispatch = {
  updateFeatures,
};

export const ToggleFeatures = connectWithStore(mapStateToProps, mapComponentStateToDispatch)(ToggleFeaturesComponent);
